function logout() {
  const baseUrl = process.env.VUE_APP_AUTH0_CORP_DOMAIN
  const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID
  const returnTo = `${window.location.origin}/login`

  const logoutUrl = new URL(`${baseUrl}/v2/logout`)
  logoutUrl.searchParams.append('client_id', clientId)
  logoutUrl.searchParams.append('returnTo', returnTo)

  window.location.href = logoutUrl.toString()
}

function login() {
  const identityBaseUrl = `${process.env.VUE_APP_ENVIRONMENT}/identity`
  const loginUrl = `${identityBaseUrl}/v1/adminaccount/login`

  window.location.href = loginUrl
}

export default {
  logout,
  login,
}
